import { FC, ReactNode } from 'react';

interface IconProps {
  /** Square icon size in px */
  size?: number;
  strokeWidth?: number;
}

/** Shared 24×24 stroke-icon frame; color comes from the parent's CSS `color`. */
const Icon: FC<IconProps & { children: ReactNode }> = ({
  size = 24,
  strokeWidth = 2,
  children,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {children}
  </svg>
);

export const MailIcon: FC<IconProps> = props => (
  <Icon {...props}>
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="m22 7-10 5L2 7" />
  </Icon>
);

export const PhoneIcon: FC<IconProps> = props => (
  <Icon {...props}>
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />
  </Icon>
);

export const ClockIcon: FC<IconProps> = props => (
  <Icon {...props}>
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </Icon>
);

export const ChevronDownIcon: FC<IconProps> = props => (
  <Icon strokeWidth={2.5} {...props}>
    <polyline points="6 9 12 15 18 9" />
  </Icon>
);
